import DealStructure from './DealStructure'
export default DealStructure
